import { useMutation } from "@tanstack/react-query"
import { Button } from "components"
import CustomModal from "components/new-stuff/ui/modals/CustomModal"
import React from "react"
import { useAppNotificationStore } from "stores"
import getIdFromKey from "utils/getIdFromKey"
import { payrollService } from "services/payrollService"
import { onQueryError } from "utils/utils"

const EmailPayslipModal: React.FC<{
  closeModal: Function

  payrollId: string
  personId: string
}> = ({ closeModal, payrollId, personId }) => {
  const { toast } = useAppNotificationStore()

  const { isLoading: loadingChangeAdmin, mutate: submit } = useMutation({
    mutationFn: async () => {
      return await payrollService.emailSinglePayslip(
        getIdFromKey(payrollId),
        personId
      )
    },
    onSuccess: (data) => {
      toast.success(data.message)
      closeModal()
    },
    onError: onQueryError,
  })

  return (
    <div>
      <CustomModal
        onCancel={() => {
          closeModal()
        }}
        open
        title="Email Employee"
        footer={
          <div className="flex justify-end">
            <Button
              color="neutral"
              onClick={() => {
                closeModal()
              }}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                submit()
              }}
              disabled={loadingChangeAdmin}
              submitting={loadingChangeAdmin}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <div>
          <p className="text-[#15294B] text-sm mb-6 text-center">
            We will email employee with instructions on how to view their
            payslip. Click Confirm to continue.
          </p>
        </div>
      </CustomModal>
    </div>
  )
}
export default EmailPayslipModal
